export default __webpack_public_path__ + "static/media/zendesk-long.26ff87c8.svg";